import { useIntl } from 'react-intl';

import { Typography } from '@/components/Typography';
import { commonMessages } from '@/messages/common';

import { ReactComponent as ExchangeTheGiftsIcon } from '@/assets/4gift-exchange-the-gift.svg';

import * as S from '../SendGiftModal.styles';

export const ExchangeTheGifts = () => {
  const { formatMessage } = useIntl();
  return (
    <S.InfoBoxBody>
      <ExchangeTheGiftsIcon />
      <Typography
        fontFamily='italianPlate'
        fontWeight='bold'
        mb='s035'
        mt='s035'
        scale='p0'
        textTransform='uppercase'
      >
        {formatMessage(commonMessages.sendGiftExchangeGift)}
      </Typography>
      <Typography textAlign='center'>
        {formatMessage(commonMessages.sendGiftExchangeGiftDesc)}
      </Typography>
    </S.InfoBoxBody>
  );
};
